<template>
  <span class="multiselect__objective-name">{{ option.objectiveName }} </span>
  <span class="multiselect__objective-level">
    <span class="multiselect__order">Level {{ option.order }}:&nbsp;</span>
    <span class="multiselect__level-name">{{ option.name }}</span>
  </span>
</template>
<script setup lang="ts">
import { API } from "@/programs/types.ts";
defineProps<{
  option: API.Admin.LevelOption;
}>();
</script>
